<template>
  <div>
    <vx-card title="Сотрудники">
        <div slot="no-body" class="mt-4">
          <vs-table :data="list">
            <template slot="thead">
              <vs-th>ID</vs-th>
              <vs-th>ИМЯ</vs-th>
              <vs-th>НОМЕР ТЕЛЕФОНА</vs-th>
              <vs-th>ДОЛЖНОСТЬ</vs-th>
              <vs-th>ЛОКАЦИЯ</vs-th>
              <vs-th>ОТДЕЛ</vs-th>
              <vs-th>ДАТА</vs-th>
              <vs-th>ДЕЙСТВИЯ</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].orderNo">
                  <span>{{data[indextr].orderNo}}</span>
                </vs-td>
                <vs-td :data="data[indextr].orderNo">
                  <span @click="()=>$router.push('/specialist/'+data[indextr].id)">{{data[indextr].fullname}}</span>
                </vs-td>
                <vs-td :data="data[indextr].orderNo">
                  <span>{{data[indextr].phone}}</span>
                </vs-td>
                <vs-td :data="data[indextr].orderNo">
                  <span>{{data[indextr].specialty}}</span>
                </vs-td>
                <vs-td :data="data[indextr].orderNo">
                  <span>{{ getLocationName(data[indextr].location_id)  }}</span>
                </vs-td>
                <vs-td :data="data[indextr].orderNo">
                  <span>{{getDepartmentName(data[indextr].department_id)}}</span>
                </vs-td>
                <vs-td :data="data[indextr].orderNo">
                  <span>{{data[indextr].date}}</span>
                </vs-td>
                <vs-td :data="data[indextr].orderNo">
                  <span style="width: 4em; font-size:1.35em; display:flex; justify-content:space-between;">
                    <i class="feather icon-settings" @click="()=>$router.push('/specialist/'+data[indextr].id)"></i>
                    <i class="feather icon-trash" @click="()=>{itemName=data[indextr].fullname||'Без названия'; itemToDel=[data[indextr].id]; isPopupDel=true}"></i>
                  </span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
      <div @click="$router.push('/specialist/add')" class="cursor-pointer"  
        style="margin:1em 0; padding:1.5em; width:100%; font-weight:bold; border: 2px dashed #ccc; text-align:center">
        <span><i style="font-size:1.75em; vertical-align:middle;" class="feather icon-plus"></i>ДОБАВИТЬ СОТРУДНИКА</span>
      </div>
      <vs-popup class="holamundo" title="" :active.sync="isPopupDel">
            
              <div class="flex mt-6 flex-wrap">
                <span style="text-align:center; width:100%">Вы действительно хотите <br>удалить елемент <b>{{ itemName }}</b>?</span>
              </div>
              
              <div class="flex mt-6 flex-wrap" style="display:flex;width:100%;justify-content:space-between">
                <vs-button 
                  class="tools__btn"
                    color="danger"
                    @click="()=>deleteItem( itemToDel )"
                    >Удалить</vs-button>
                <vs-button 
                  class="tools__btn"
                    color="light"
                    style="justify-self: end; color:#555"
                    @click="()=>{isPopupDel = false; itemToDel = []; itemName = ''}"
                    >Отмена</vs-button>
              </div>
          </vs-popup>
  </div>
</template>
<script>
  import API from 'API';

  export default {
    data(){
      return {
        'tableList': [
          'vs-th: Component',
          'vs-tr: Component',
          'vs-td: Component',
          'thread: Slot',
          'tbody: Slot',
          'header: Slot'
        ],
        list: [],
        locationList: [],
        departmentList: [],
        
        isPopupDel:false,
        itemToDel:[],
        itemName:''
      }
    },
    methods:{
      getLocationName(location_id){
        for (let item of this.locationList)
          if (item.id == location_id)
            return item.name;
      },
      getDepartmentName(department_id){
        for (let item of this.departmentList)
          if (item.id == department_id)
            return item.name;
      },
      getList(){
        this.list = [];
        let self = this;
        return API.user.getSpecialistList( localStorage.workspace_id )
          .then(e => {
            console.log(e.data);
            if (e.data){
              e.data.forEach(e=>{
                e.orderNo = e.id;
                e.date = e.updated_at.split(' ')[0]
                self.list.push(e)
              })
              this.$notify({
                group: 'foo',
                type: 'success',
                title: 'Сотрудники получено',
                text: 'Успешно!'
              });
            }
            return true;
          })
          .catch(err => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Ошибка запроса Сотрудники',
              text: err
            });
          })
      },
      switchItem(item, el){
        
        if (el.target && !!el.target.value == "false"){//disable

          API.user.disableSpecialist(
              {
                id:item
              }
            )
        }
        if (el.target && !!el.target.value == "true"){ //enable

          API.user.ableSpecialist(
              {
                id:item
              }
            )
        }

      },
      deleteItem(itemToDel){
        
        let item = itemToDel[0];

        let i = 0;
        for (let el of this.list){
          if (el.id == item) {
            this.list.splice(i,1)
            break;
          }
          i++
        }
        
        API.user.deleteSpecialist(
            {
              id:item
            }
          ).then(()=>this.isPopupDel=false).catch(()=>this.isPopupDel=false)
      }

      
    },
    created() {
      
      API.user.getLocationList( localStorage.workspace_id )
          .then(e => {
            this.locationList = e.data;
          })
      API.user.getDepartmentList( localStorage.workspace_id )
          .then(e => {
            this.departmentList = e.data;
          })

      this.getList()
        .then(()=>{
          console.log('list',this.list)
        })
    }
  }
</script>
<style lang="css" scoped>
  .icon-trash, .icon-settings{
    cursor: pointer;
  }
</style>